import { Box } from '@zillow/constellation-10';
import { LoadingText } from '@zg-rentals/loading-components';
import type { ReactNode } from 'react';

type ModalState = {
  header: ReactNode;
  body: ReactNode;
  footer: ReactNode;
};

export const Skeleton = (): ModalState => {
  const header = (
    <LoadingText isLoading loadingWidth="60%">
      Loading header
    </LoadingText>
  );

  const body = (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'default',
        padding: 'default',
      }}
    >
      <LoadingText isLoading loadingWidth="60%">
        Loading title
      </LoadingText>
      <LoadingText isLoading loadingWidth="80%">
        Loading description
      </LoadingText>
    </Box>
  );

  const footer = (
    <LoadingText isLoading loadingWidth="30%">
      Loading description
    </LoadingText>
  );

  return { header, body, footer };
};
